import { isNil } from '@seedcloud/ramda-extra'

export function calcStartRow(newNext, limit, paging) {
  if (isNil(newNext)) {
    return isNil(paging.startRow) ? undefined : paging.startRow + limit
  }
  return newNext - limit >= 0 ? newNext - limit : undefined
}
